/* Skeleton loading global — shimmer nas mídias de conteúdo enquanto a imagem carrega.
   Ignora: chrome (header/footer/megamenu/busca), ícones/miniaturas (<80px) e opt-out
   via classe .sv-noskel ou atributo data-no-skel. Cobre conteúdo inserido depois
   (busca preditiva, quick-add, carrinho) via MutationObserver. */
(function () {
  var MIN = 80;
  var SKIP_ANCESTOR = '.sv-header, .sv-footer, .sv-mm, .sv-mega, .sv-psearch, .sv-drawer, .sv-wa, .sv-swipe-hint, [data-no-skel]';

  function eligible(img) {
    if (img.classList.contains('sv-noskel') || img.hasAttribute('data-no-skel')) return false;
    if (img.closest && img.closest(SKIP_ANCESTOR)) return false;
    // miniaturas / ícones: pula pela largura declarada
    var w = parseInt(img.getAttribute('width') || '0', 10);
    if (w && w < MIN) return false;
    return true;
  }

  function done(img) {
    img.classList.remove('sv-loading');
    img.classList.add('sv-loaded');
  }

  function watch(img) {
    if (img.__svSkel) return;
    img.__svSkel = 1;
    if (!eligible(img)) return;
    if (img.complete && img.naturalWidth > 0) { done(img); return; }
    img.classList.add('sv-loading');
    img.addEventListener('load', function () { done(img); }, { once: true });
    img.addEventListener('error', function () { done(img); }, { once: true });
  }

  function scan(root) {
    (root || document).querySelectorAll('img').forEach(watch);
  }

  function boot() {
    scan();
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IMG') watch(n);
          else if (n.querySelectorAll) scan(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
